import { rnd } from "../components/MainPage";
import { orderTypeEnum } from "../components/consts";

export const generateSteppedYArray = (min = 10, max = 500, step = 10) => {
  const result = [16];
  const steps = Array.from(
    { length: (max - min) / step + 1 },
    (_, i) => min + i * step
  );
  result.push(...steps);
  return result;
};

export const getRandomTypeAndRate = ({ orders }) => {
  const xyOrderX = rnd(1, 5);
  const xyOrderYSteps = generateSteppedYArray(20, 500, 10); // Start from 16 as 15 is handled separately
  const lshOrderX = 5;
  const lshOrderY = undefined;

  let types = [orderTypeEnum.xy, orderTypeEnum.lsb, orderTypeEnum.lsh];
  const lshCount = orders.filter(e => e.type === "LSH").length;
  const lsbCount = orders.filter(e => e.type === "LSB").length;
  if (lshCount === 1 && lsbCount === 1) {
    types = [orderTypeEnum.xy];
  } else if (lshCount === 1) {
    types = [orderTypeEnum.xy, orderTypeEnum.lsb];
  } else if (lsbCount === 1) {
    types = [orderTypeEnum.xy, orderTypeEnum.lsh];
  }

  const type = types[rnd(0, types.length - 1)];

  const streamRate = {
    x: undefined,
    y: undefined
  };
  switch (type) {
    case "LSH":
      streamRate.x = lshOrderX;
      streamRate.y = lshOrderY;
      break;
    case "XY":
      streamRate.x = xyOrderX;
      // 80% chance to be 15, 20% chance to be a random value from 16 to 500
      streamRate.y =
        rnd(1, 100) <= 80
          ? 15
          : xyOrderYSteps[rnd(0, xyOrderYSteps.length - 1)];
      break;
    default:
      break;
  }
  return {
    type,
    streamRate
  };
};
